import React, { ReactElement } from "react";
import { RenteaftrekData } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../../../components/BaseTable";
import Table from "../../../../components/Table";

export const RenteAftrekTabel = ({
  data,
}: {
  data: RenteaftrekData[];
}): ReactElement => {
  const columns: Column[] = [
    {
      header: "Soort",
      accessor: "soort",
    },
    {
      header: "Ingangsdatum*",
      accessor: "aanvangsdatum",
      dataType: "date",
    },
    {
      header: "Einddatum*",
      accessor: "einddatum",
      dataType: "date",
    },
    {
      header: "Bruto maandlast",
      accessor: "brutoMaandlast",
      dataType: "currency",
    },
    {
      header: "Totaal",
      accessor: "bedrag",
      dataType: "currency",
    },
    {
      header: "Renteaftrek tijdens looptijd",
      accessor: "verloop",
    },
  ];

  return (
    <>
      <Table data={data ?? /*istanbul ignore next*/ []} columns={columns} id="rente-aftrek-table" />
      <div
        className="text-left font-italic mt-2"
        style={{ captionSide: "bottom" }}
      >
        * Ingangsdatum/ einddatum van de renteaftrek
      </div>
    </>
  );
};
